import { connect } from 'react-redux';
import PersonalDetailsComponent from './PersonalDetailsComponent';
import Configs from '../../../../conf';
import { getDropdownOptions } from '../../../../services/Translation';
import {
  getCountries,
  getOccupations,
} from '../../../../state/reducers/ConfigReducer';
import {
  getData,
  getFormErrors,
  getValidators,
  isRequired,
  getError,
} from '../../../../state/reducers/ApplicationReducer';
import { getLanguage } from '../../../../state/reducers/AppReducer';
import ApplicationActions from '../../../../state/actions/ApplicationActions';

const mapStateToProps = (state) => {
  const data = getData(state);
  const validators = getValidators(state);
  const errors = getFormErrors(state);
  const lang = getLanguage(state);
  return {
    surname: data.nameLast || '',
    surnameError: errors.nameLast,
    isSurnameRequired: isRequired(validators.nameLast),
    firstName: data.nameFirst || '',
    firstNameError: errors.nameFirst,
    isFirstNameRequired: isRequired(validators.nameFirst),
    dob: data.dob || '',
    dobError: errors.dob,
    isDobRequired: isRequired(validators.dob),
    countries: getDropdownOptions(getCountries(state), lang),
    countryOfBirth: data.nationalityOriginId || null,
    countryOfBirthError: errors.nationalityOriginId,
    isCountryOfBirthRequired: isRequired(validators.nationalityOriginId),
    cityOfBirth: data.pob || '',
    cityOfBirthError: errors.pob,
    isCityOfBirthRequired: isRequired(validators.pob),
    gender: data.sex || '',
    genderError: errors.sex,
    isGenderRequired: isRequired(validators.sex),
    genders: getDropdownOptions(Configs.genders, lang),
    relationshipStatuses: getDropdownOptions(
      Configs.relationshipStatuses,
      lang
    ),
    relationshipStatus: data.relStatus || null,
    isRelationshipStatusRequired: isRequired(validators.relStatus),
    relationshipStatusError: errors.relStatus,
    occupations: getDropdownOptions(getOccupations(state), lang),
    occupation: data.occupationId || null,
    occupationError: errors.occupationId,
    isOccupationRequired: isRequired(validators.occupationId),
    numberOfChildren: data.noChildren ? data.noChildren.toString() : '',
    numberOfChildrenError: errors.noChildren,
    isNumberOfChildrenRequired: isRequired(validators.noChildren),
    error: getError(state),
  };
};

const { formValueChanged } = ApplicationActions;
const mapDispatchToProps = (dispatch) => ({
  surnameChanged: (value) => {
    dispatch(formValueChanged('nameLast', value));
  },
  firstNameChanged: (value) => {
    dispatch(formValueChanged('nameFirst', value));
  },
  dobChanged: (value) => {
    dispatch(formValueChanged('dob', value));
  },
  countryOfBirthChanged: (value) => {
    dispatch(formValueChanged('nationalityOriginId', value));
  },
  cityOfBirthChanged: (value) => {
    dispatch(formValueChanged('pob', value));
  },
  countryOfCitizenshipChanged: (value) => {
    dispatch(formValueChanged('nationalityCurrentId', value));
  },
  genderChanged: (value) => {
    dispatch(formValueChanged('sex', value));
  },
  relationshipStatusChanged: (value) => {
    dispatch(formValueChanged('relStatus', value));
  },
  occupationChanged: (value) => {
    dispatch(formValueChanged('occupationId', value));
  },
  numberOfChildrenChanged: (value) => {
    dispatch(formValueChanged('noChildren', value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PersonalDetailsComponent);



// WEBPACK FOOTER //
// ./src/view/forms/Application/PersonalDetails/index.js